import React from 'react';

/**
 * This component wraps a list of avatars and render them in a group.
 */
export const AvatarGroup: React.FC = ({ children }): JSX.Element => {
  return (
    <div className="h-10 w-10 relative flex items-center gap-2 [&>*]:absolute [&>*]:bottom-0 [&>*:first-child]:-bottom-1 [&>*:first-child]:z-[2] [&>*:nth-child(2)]:left-1.5 [&>*:nth-child(2)]:bottom-3.5 [&>*:nth-child(2)]:z-[1]">
      {children}
    </div>
  );
};
